import React from 'react'
import PropTypes from 'prop-types'
import Skeleton from '../../../../atoms/Skeleton'
import { cssVar } from '../../../../../utils/cssVar'

const BAR_WIDTHS = ['75%', '60%', '85%', '45%', '70%']

export function ChartLoading ({ className, style, minHeight, heightPerBar }) {
  return (
    <div className={className} style={{ ...style, height: minHeight, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: heightPerBar * 0.3, padding: '20px' }}>
      {BAR_WIDTHS.map((w, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Skeleton width='80px' height='14px' />
          <Skeleton width={w} height={`${Math.round(heightPerBar * 0.4)}px`} />
        </div>
      ))}
    </div>
  )
}

ChartLoading.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  minHeight: PropTypes.number,
  heightPerBar: PropTypes.number
}

export function ChartError ({ className, style, minHeight }) {
  return (
    <div className={className} style={{ ...style, height: minHeight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: cssVar('--color-error') || '#dc2626', fontSize: 14 }}>Failed to load allocation data</div>
    </div>
  )
}

ChartError.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  minHeight: PropTypes.number
}

export function ChartEmpty ({ className, style, minHeight }) {
  return (
    <div className={className} style={{ ...style, height: minHeight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: cssVar('--text-color-main') || '#999', fontSize: 14 }}>No allocation data</div>
    </div>
  )
}

ChartEmpty.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  minHeight: PropTypes.number
}
